export default {
  setAppHeight({
    commit
  }, payload) {
    commit('SET_APP_HEIGHT', payload);
  },
  setShowDetail({
    commit
  }, payload) {
    commit('SET_SHOW_DETAIL', payload);
  },
  setNavigations({
    commit,
    dispatch
  }, payload) {
    commit('SET_NAVIGATION_LIST', payload.list);
    dispatch('setNavigationActive', payload.active);
    dispatch('setNavigationAction', payload.action)
  },
  setNavigationActive({
    commit
  }, payload) {
    commit('SET_NAVIGATION_ACTIVE', payload);
  },
  setNavigationAction({
    commit
  }, payload) {
    commit('SET_NAVIGATION_ACTION', payload);
  },
  refetchBadge({
    commit
  }, payload) {
    commit('SET_REFETCH_BADGE', payload)
  },
  toggleCreate({
    commit
  }, payload) {
    commit('TOGGLE_CREATE', payload);
  },
  setCreateTitle({
    commit
  }, payload) {
    commit('SET_CREATE_TITLE', payload);
  },
  setHeaderTitle({
    commit
  }, payload) {
    commit('SET_HEADER_TITLE', payload);
  },
  setHeaderSubtitle({
    commit
  }, payload) {
    commit('SET_HEADER_SUBTITLE', payload);
  },
  toggleSearch({
    commit
  }, payload) {
    commit('TOGGLE_SEARCH', payload);
  },
  setQuerySearch({
    commit
  }, payload) {
    commit('SET_QUERY_SEARCH', payload);
  },
  toggleFilter({
    commit
  }, payload) {
    return new Promise((resolve) => {
      commit('TOGGLE_FILTER', payload);
      resolve();
    });
  },
  setFilterForms({
    commit
  }, payload) {
    commit('SET_FILTER_FORMS', payload);
  },
  setFilterType({
    commit,
    getters
  }, payload) {
    let filterObject = getters.fetchFilterSelected(payload);
    commit('SET_FILTER_TYPE', payload);
    commit('SET_FILTER_QUERY', {}); // set default kata kunci
    commit('SET_FILTER_OBJECT', filterObject);
  },
  setFilterQuery({
    commit
  }, payload) {
    commit('SET_FILTER_QUERY', payload);
  },
  setFilterToDefault({
    commit
  }) {
    return new Promise((resolve) => {
      commit('SET_FILTER_TYPE', '');
      commit('SET_FILTER_OBJECT', {});
      resolve();
    });
  },
  pushFilterList({
    commit
  }, payload) {
    commit('PUSH_FILTER_LIST', payload);
  },
  async submitFilter({
    dispatch
  }, payload) {
    await dispatch('pushFilterList', payload);
    await dispatch('setFilterToDefault');
    dispatch('toggleFilter', false);
  },
  removeFilter({
    commit
  }, payload) {
    commit('REMOVE_FILTER', payload);
  },
  emptyFilterList({
    commit
  }) {
    commit('EMPTY_FILTER_LIST');
  },

  // Edit
  toggleEdit({
    commit
  }, payload) {
    commit('TOGGLE_EDIT', payload);
  },
  setEditTitle({
    commit
  }, payload) {
    commit('SET_EDIT_TITLE', payload);
  },
  setProfileAvatar({
    commit,
  }, payload) {
    commit('SET_PROFILE_AVATAR', payload);
  },
  reloadNotificationData({
    commit,
  }, payload) {
    commit('RELOAD_NOTIFICATION_DATA', payload);
  }
};
